@if (pageEvent.length > 0) {
    <div class="container-navigation navigation is-flex is-align-items-center">

        <div class="is-hidden-touch">
            <p
                    class="mr-2 is-size-7 is-white-space-nowrap has-text-grey">{{ pageEvent.length }}
                @if (pageEvent.length > 1) {
                    <span>{{ labelPlural }}</span>
                }
                @if (pageEvent.length <= 1) {
                    <span>{{ labelSingle }}</span>
                }
            </p>
        </div>
        @if (pageEvent.activePage > 1) {
            <a
                    [routerLink]="getSSRRouterLink(pageEvent.activePage-1)"
                    [queryParams]="getSSRRouterLinkQueryParams()"
                    (click)="setPage(pageEvent.activePage-1)" class="button mr-2-touch">
                <fa-icon [icon]="faArrowLeft" class="ml-2 mr-2"></fa-icon>
                Vorherige Seite
            </a>
        }
        <nav class="pagination is-hidden-touch is-hidden-desktop-only" role="navigation" [attr.aria-label]="ariaLabel">
            <ul class="pagination-list">
                @for (page of pageEvent.pages; track page) {
                    <li>
                        @if (page == '...') {
                            <span class="pagination-ellipsis">&hellip;</span>
                        }
                        @if (page == 1) {
                            <a class="pagination-link is-current"
                               [routerLink]="getSSRRouterLink(page)"
                               [queryParams]="getSSRRouterLinkQueryParams()"
                               (click)="setPage(page)"
                               [class.is-current]="page === pageEvent.activePage">{{ page }}</a>
                        }
                        @if (page !== '...' && page !== 1) {
                            <a class="pagination-link"
                               [routerLink]="getSSRRouterLink(page)"
                               [queryParams]="getSSRRouterLinkQueryParams()"
                               (click)="setPage( page)"
                               [class.is-current]="page === pageEvent.activePage">{{ page }}</a>
                        }
                    </li>
                }
            </ul>
        </nav>
        @if (pageEvent.countPages > pageEvent.activePage) {
            <a [routerLink]="getSSRRouterLink(pageEvent.activePage+1)"
               [queryParams]="getSSRRouterLinkQueryParams()"
               (click)="setPage(pageEvent.activePage+1)"
               class="button">Nächste Seite
                <fa-icon [icon]="faArrowRight" role="img" aria-label="Zur nächsten Seite"
                         class="ml-2"></fa-icon>
            </a>
        }
    </div>
    <div class="is-hidden-desktop has-text-centered mt-4">
        <p
                class="mr-2 is-size-7 is-white-space-nowrap has-text-grey">Seite {{ pageEvent.activePage }}
            von
            {{ pageEvent.countPages }}</p>
    </div>
}


